import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { AddViaSalesReleaseReferenceButtonComponent } from './add-via-sales-release-reference-button/add-via-sales-release-reference-button.component';
import { AddViaPurchaseReleaseReferenceButtonComponent } from './add-via-purchase-release-reference-button/add-via-purchase-release-reference-button.component';
import { AddViaSalesInvoiceButtonComponent } from './add-via-sales-invoice-button/add-via-sales-invoice-button.component';
import { AddViaPurchaseInvoiceButtonComponent } from './add-via-purchase-invoice-button/add-via-purchase-invoice-button.component';
import { AddViaIndentButtonComponent } from './add-via-indent-button/add-via-indent-button.component';
import { AddViaPurchaseOrderButtonComponent } from './add-via-purchase-order-button/add-via-purchase-order-button.component';
import { PurchaseReleaseDetailDTO, PurchaseReleaseDetailCreateBulkRequestDTO } from 'src/app/purchase/purchase-release/purchase-release-detail/purchase-release-detail.interface';
import { PurchaseReleaseDetailService } from 'src/app/purchase/purchase-release/purchase-release-detail/purchase-release-detail.service';
import {  PurchaseDetailDTO, PurchaseDetailUpsertBulkRequestDTO } from 'src/app/purchase/purchase/purchase-detail/purchase-detail.interface';
import { PurchaseDetailService } from 'src/app/purchase/purchase/purchase-detail/purchase-detail.service';
import { SalesReleaseDetailDTO, SalesReleaseDetailCreateBulkRequestDTO } from 'src/app/sale/sales-release/sales-release-detail/sales-release-detail.interface';
import { SalesReleaseDetailService } from 'src/app/sale/sales-release/sales-release-detail/sales-release-detail.service';
import { SalesDetailDTO, SalesDetailUpsertBulkRequestDTO } from 'src/app/sale/sales/sales-detail/sales-detail.interface';
import { SalesDetailService } from 'src/app/sale/sales/sales-detail/sales-detail.service';
import { PurchaseOrderDetailService } from 'src/app/purchase/purchase-order/purchase-order-detail/purchase-order-detail.services';
import { PurchaseOrderDetailCreateBulkRequestDTO } from 'src/app/purchase/purchase-order/purchase-order-detail/purchase-order-detail.interface';
import { ObjectConfigMappingService } from 'src/app/Common/ObjectConfigMapping/ObjectConfigMapping.service';
import { ActivatedRoute } from '@angular/router';
import { ObjectConfigMappingByMenuCodeDTO } from 'src/app/Common/ObjectConfigMapping/ObjectConfigMapping.interface';
import { ensureNumber, ensureString } from '../customFunctions/CustomFunctions';
import { ValueListService } from 'src/app/Common/ValueListService/value-list.service';


@Component({
  selector: 'app-import-cross-invoices-button',
  templateUrl: './import-cross-invoices-button.component.html',
  styleUrls: ['./import-cross-invoices-button.component.css']
})
export class ImportCrossInvoicesButtonComponent {
  @Input({ required: true }) MasterId: number = 0;
  @Input({ required: true }) MasterType: 'SalesRelease' | 'PurchaseInvoice' | 'PurchaseRelease' | 'SalesInvoice' | 'PurchaseOrder' | 'Indent' = 'SalesRelease';
  @Input() EnablePriceEdit: boolean = false
  @Input() disabled: boolean = false;
  @Output() ReloadList: EventEmitter<void> = new EventEmitter<void>();

  User = inject(UserLoginService).User();

  ngOnInit() {
    let r = this.route;
    while (r.firstChild) r = r.firstChild;

    const currentPath = r.routeConfig?.path ?? '';
    const parentPath = r.parent?.routeConfig?.path ?? '';

    const normalize = (path: string) =>
      path.split('/').find(p => !p.startsWith(':')) ?? '';

    const result =
      normalize(currentPath) || normalize(parentPath);

    this.getObjectId(result);
    this.getDefaultItemTaxConfig();

  }

  @ViewChild('SalesReleaseReference') SalesReleaseReference!: AddViaSalesReleaseReferenceButtonComponent;
  @ViewChild('PurchaseReleaseReference') PurchaseReleaseReference!: AddViaPurchaseReleaseReferenceButtonComponent;
  @ViewChild('SalesInvoiceReference') SalesInvoiceReference!: AddViaSalesInvoiceButtonComponent;
  @ViewChild('PurchaseInvoiceReference') PurchaseInvoiceReference!: AddViaPurchaseInvoiceButtonComponent;
  @ViewChild('IndentReference') IndentReference!: AddViaIndentButtonComponent;
  @ViewChild('PurchaseOrderReference') PurchaseOrderReference!: AddViaPurchaseOrderButtonComponent;

  salesDetailService = inject(SalesDetailService);
  salesReleaseDetailService = inject(SalesReleaseDetailService);
  purchaseReleaseDetailService = inject(PurchaseReleaseDetailService);
  purchaseDetailService = inject(PurchaseDetailService);
  purchaseOrderDetailService = inject(PurchaseOrderDetailService);
  valueListService = inject(ValueListService);

  // First active "DIT" ValueList item's vliCode (e.g. "18"); blank when not configured.
  defaultItemTax: string = '';

  getDefaultItemTaxConfig() {
    this.valueListService.ValueListItem_readByVlCode({
      vlCode: 'DIT',
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    }).subscribe({
      next: (res) => {
        const item = (res?.items || []).find(x => x.isActive !== 0 && (x.vliCode || '').trim() !== '');
        this.defaultItemTax = (item?.vliCode || '').trim();
      },
      error: () => this.defaultItemTax = ''
    });
  }

  handleSubmit(importingFrom: 'SalesRelease' | 'PurchaseInvoice' | 'PurchaseRelease' | 'SalesInvoice' | 'Indent' | 'PurchaseOrder',
    items: SalesReleaseDetailDTO[] | PurchaseDetailDTO[] | PurchaseReleaseDetailDTO[] | SalesDetailDTO[] | any[]) {
    // Rows imported without a tax (gstRate blank/0) get the tenant's "DIT" ValueList default;
    // with no DIT configured they are sent exactly as imported.
    const rate = parseFloat(this.defaultItemTax);
    const rows = isNaN(rate) ? items : (items as any[]).map(el =>
      ensureNumber(el.gstRate) > 0 ? el : { ...el, gstRate: rate });
    this.routeToMaster(rows, this.MasterType, importingFrom);
    // switch (importingFrom) {
    //   case 'SalesRelease':
    //     console.log(items);

    //     this.routeToMaster(items, this.MasterType, importingFrom);
    //     break;
    //   case 'PurchaseInvoice':
    //     this.routeToMaster(items, this.MasterType, importingFrom);
    //     break;
    //   case 'PurchaseRelease':
    //     this.routeToMaster(items, this.MasterType, importingFrom);
    //     break;
    //   case 'SalesInvoice':
    //     this.routeToMaster(items, this.MasterType, importingFrom);
    //     break;
    //   case 'Indent':
    //     this.routeToMaster(items, this.MasterType, importingFrom);
    //     break;
    //   default:
    //     console.warn('Unknown importingFrom:', importingFrom);
    //     break;
    // }
  }

  private routeToMaster(items: any[], masterType: string, importingFrom: string) {
    switch (masterType) {
      case 'SalesInvoice':
        this.CreateSalesDetail(items as SalesDetailDTO[], importingFrom);
        break;
      case 'SalesRelease':
        this.CreateSalesReleaseDetail(items as SalesReleaseDetailDTO[], importingFrom);
        break;
      case 'PurchaseInvoice':
        this.CreatePurchaseDetail(items as PurchaseDetailDTO[], importingFrom);
        break;
      case 'PurchaseRelease':
        this.CreatePurchaseReleaseDetail(items as PurchaseReleaseDetailDTO[], importingFrom);
        break;
      case 'PurchaseOrder':
        this.CreatePurchaseOrderDetail(items as any[], importingFrom);
        break;
      default: console.warn(`${importingFrom} import ignored, MasterType not matched`);
        break;
    }
  }

  // ------------------- Helper Methods -------------------
  private setSubmitting(importingFrom: string, value: boolean) {
    switch (importingFrom) {
      case 'SalesRelease': this.SalesReleaseReference.isSubmitting = value; break;
      case 'PurchaseRelease': this.PurchaseReleaseReference.isSubmitting = value; break;
      case 'SalesInvoice': this.SalesInvoiceReference.isSubmitting = value; break;
      case 'PurchaseInvoice': this.PurchaseInvoiceReference.isSubmitting = value; break;
      case 'Indent': this.IndentReference.isSubmitting = value; break;
      case 'PurchaseOrder': this.PurchaseOrderReference.isSubmitting = value; break;
    }
  }

  private closeModal(importingFrom: string) {
    switch (importingFrom) {
      case 'SalesRelease': this.SalesReleaseReference.ReleaseModalRef.close(); break;
      case 'PurchaseRelease': this.PurchaseReleaseReference.ReleaseModalRef.close(); break;
      case 'SalesInvoice': this.SalesInvoiceReference.ReleaseModalRef.close(); break;
      case 'PurchaseInvoice': this.PurchaseInvoiceReference.purchaseModalRef.close(); break;
      case 'Indent': this.IndentReference.IndentModalRef.close(); break;
      case 'PurchaseOrder': this.PurchaseOrderReference.purchaseOrderModalRef.close(); break;
    }
  }

  // ------------------- Create Methods -------------------
  CreateSalesDetail(items: SalesDetailDTO[], importingFrom: string) {
    if (!items?.length) return;

    this.setSubmitting(importingFrom, true);

    const refMasterIdKey =
      (importingFrom === 'SalesRelease' || importingFrom === 'PurchaseRelease') ? 'releaseId' :
        (importingFrom === 'PurchaseInvoice' || importingFrom === 'SalesInvoice') ? 'invoiceId' :
          (importingFrom === 'Indent') ? 'indentId' :
            (importingFrom === 'PurchaseOrder') ? 'purchaseOrderId' : '';

    const refDetailIdKey = importingFrom === 'PurchaseOrder' ? 'purchaseOrderDetailId' : 'detailId';

    const payload: SalesDetailUpsertBulkRequestDTO = {
      invoiceId: this.MasterId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      actionUser: this.User.userId.toString(),
      salesDetails: items.map(el => ({
        itemId: ensureNumber(el.itemId),
        qtyType: ensureString(el.qtyType),
        qty: ensureNumber(el.qty),
        price: ensureNumber(el.price),
        discount: ensureNumber(el.discount),
        discountRate: ensureNumber(el.discountRate),
        totalAmount: ensureNumber(el.totalAmount) || (ensureNumber(el.price) * ensureNumber(el.qty)),
        remarks: ensureString(el.remarks),
        displaySeq: ensureNumber(el.displaySeq),
        otherDetail1: ensureString(el.otherDetail1),
        otherDetail2: ensureString(el.otherDetail2),
        otherDetail3: ensureString(el.otherDetail3),
        otherDetail4: ensureString(el.otherDetail4),
        otherDetail5: ensureString(el.otherDetail5),
        otherDetail6: ensureString(el.otherDetail6),
        otherDetail7: ensureString(el.otherDetail7),
        otherDetail8: ensureString(el.otherDetail8),
        otherDetail9: ensureString(el.otherDetail9),
        otherDetail10: ensureString(el.otherDetail10),
        otherDetail11: ensureString(el.otherDetail11),
        otherDetail12: ensureString(el.otherDetail12),
        otherDetail13: ensureString(el.otherDetail13),
        otherDetail14: ensureString(el.otherDetail14),
        otherDetail15: ensureString(el.otherDetail15),
        tax: ensureNumber(el.tax),
        itemType: ensureString(el.itemType),
        refMasterType: ensureString(importingFrom),
        refMasterId: ensureNumber((el as any)[refMasterIdKey]),
        refDetailId: ensureNumber((el as any)[refDetailIdKey]),
        gstRate: ensureNumber(el.gstRate),
        cgstAmt: ensureNumber(el.cgstAmt),
        sgstAmt: ensureNumber(el.sgstAmt),
        igstAmt: ensureNumber(el.igstAmt),
        utgstAmt: ensureNumber(el.utgstAmt),
        cessRate: ensureNumber(el.cessRate),
        cessAmt: ensureNumber(el.cessAmt),
      }))
    };

    this.salesDetailService.SalesDetail_UpsertBulk(payload).subscribe({
      next: () => {
        this.setSubmitting(importingFrom, false);
        this.closeModal(importingFrom);
        this.ReloadList.emit();
      },
      error: err => {
        this.setSubmitting(importingFrom, false);
        console.error(`Failed to bulk add items from ${importingFrom}:`, err);
      }
    });
  }

  CreateSalesReleaseDetail(items: SalesReleaseDetailDTO[], importingFrom: string) {
    if (!items?.length) return;

    this.setSubmitting(importingFrom, true);

    const refMasterIdKey =
      (importingFrom === 'SalesRelease' || importingFrom === 'PurchaseRelease') ? 'releaseId' :
        (importingFrom === 'PurchaseInvoice' || importingFrom === 'SalesInvoice') ? 'invoiceId' :
          (importingFrom === 'Indent') ? 'indentId' :
            (importingFrom === 'PurchaseOrder') ? 'purchaseOrderId' : '';

    const refDetailIdKey = importingFrom === 'PurchaseOrder' ? 'purchaseOrderDetailId' : 'detailId';

    const payload: SalesReleaseDetailCreateBulkRequestDTO = {
      releaseId: this.MasterId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      actionUser: this.User.userId.toString(),
      salesReleaseDetails: items.map(el => ({
        itemId: ensureNumber(el.itemId),
        qtyType: ensureString(el.qtyType),
        qty: ensureNumber(el.qty),
        remarks: ensureString(el.remarks),
        displaySeq: ensureNumber(el.displaySeq),
        otherDetail1: ensureString(el.otherDetail1),
        otherDetail2: ensureString(el.otherDetail2),
        otherDetail3: ensureString(el.otherDetail3),
        otherDetail4: ensureString(el.otherDetail4),
        otherDetail5: ensureString(el.otherDetail5),
        otherDetail6: ensureString(el.otherDetail6),
        otherDetail7: ensureString(el.otherDetail7),
        otherDetail8: ensureString(el.otherDetail8),
        otherDetail9: ensureString(el.otherDetail9),
        otherDetail10: ensureString(el.otherDetail10),
        otherDetail11: ensureString(el.otherDetail11),
        otherDetail12: ensureString(el.otherDetail12),
        otherDetail13: ensureString(el.otherDetail13),
        otherDetail14: ensureString(el.otherDetail14),
        otherDetail15: ensureString(el.otherDetail15),
        gstRate: ensureNumber(el.gstRate),
        cgstAmt: ensureNumber(el.cgstAmt),
        sgstAmt: ensureNumber(el.sgstAmt),
        igstAmt: ensureNumber(el.igstAmt),
        utgstAmt: ensureNumber(el.utgstAmt),
        cessRate: ensureNumber(el.cessRate),
        cessAmt: ensureNumber(el.cessAmt),
        refMasterType: ensureString(importingFrom),
        refMasterId: ensureNumber((el as any)[refMasterIdKey]),
        refDetailId: ensureNumber((el as any)[refDetailIdKey]),
      }))
    };

    this.salesReleaseDetailService.SalesReleaseDetail_CreateBulk(payload).subscribe({
      next: () => {
        this.setSubmitting(importingFrom, false);
        this.closeModal(importingFrom);
        this.ReloadList.emit();
      },
      error: err => {
        this.setSubmitting(importingFrom, false);
        console.error(`Failed to bulk add items from ${importingFrom}:`, err);
      }
    });
  }

  CreatePurchaseDetail(items: PurchaseDetailDTO[], importingFrom: string) {
    if (!items?.length) return;

    this.setSubmitting(importingFrom, true);

    const refMasterIdKey =
      (importingFrom === 'SalesRelease' || importingFrom === 'PurchaseRelease') ? 'releaseId' :
        (importingFrom === 'PurchaseInvoice' || importingFrom === 'SalesInvoice') ? 'invoiceId' :
          (importingFrom === 'Indent') ? 'indentId' :
            (importingFrom === 'PurchaseOrder') ? 'purchaseOrderId' : '';

    const payload: PurchaseDetailUpsertBulkRequestDTO = {
      invoiceId: this.MasterId,
      actionUser: this.User.userId.toString(),
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      purchaseDetails: items.map(el => ({
        itemId: ensureNumber(el.itemId),
        masterId: ensureNumber(el.masterId),
        masterType: ensureString(el.masterType),

        qtyType: ensureString(el.qtyType),
        qty: ensureNumber(el.qty),
        price: ensureNumber(el.price),
        discount: ensureNumber(el.discount),
        discountRate: ensureNumber(el.discountRate),
        tax: ensureNumber(el.tax),

        totalAmount:
          ensureNumber(el.totalAmount) ||
          (ensureNumber(el.price) * ensureNumber(el.qty)),

        remarks: ensureString(el.remarks),
        displaySeq: ensureNumber(el.displaySeq),
        refMasterType: ensureString(importingFrom),
        refMasterId: ensureNumber((el as any)[refMasterIdKey]),
        refDetailId: ensureNumber((el as any)['detailId']),

        isDefault: ensureNumber(el.isDefault),

        otherDetail1: ensureString(el.otherDetail1),
        otherDetail2: ensureString(el.otherDetail2),
        otherDetail3: ensureString(el.otherDetail3),
        otherDetail4: ensureString(el.otherDetail4),
        otherDetail5: ensureString(el.otherDetail5),
        otherDetail6: ensureString(el.otherDetail6),
        gstRate: ensureNumber(el.gstRate),
        cgstAmt: ensureNumber(el.cgstAmt),
        sgstAmt: ensureNumber(el.sgstAmt),
        igstAmt: ensureNumber(el.igstAmt),
        utgstAmt: ensureNumber(el.utgstAmt),

        cessRate: ensureNumber(el.cessRate),
        cessAmt: ensureNumber(el.cessAmt),
        otherDetail7: ensureString(el.otherDetail7),
        otherDetail8: ensureString(el.otherDetail8),
        otherDetail9: ensureString(el.otherDetail9),
        otherDetail10: ensureString(el.otherDetail10),
        otherDetail11: ensureString(el.otherDetail11),
        otherDetail12: ensureString(el.otherDetail12),
        otherDetail13: ensureString(el.otherDetail13),
        otherDetail14: ensureString(el.otherDetail14),
        otherDetail15: ensureString(el.otherDetail15),
      }))
    };

    this.purchaseDetailService.PurchaseDetail_UpsertBulk(payload).subscribe({
      next: () => {
        this.setSubmitting(importingFrom, false);
        this.closeModal(importingFrom);
        this.ReloadList.emit();
      },
      error: err => {
        this.setSubmitting(importingFrom, false);
        console.error(`Failed to bulk add items from ${importingFrom}:`, err);
      }
    });
  }

  CreatePurchaseReleaseDetail(items: PurchaseReleaseDetailDTO[], importingFrom: string) {
    if (!items?.length) return;

    this.setSubmitting(importingFrom, true);

    const refMasterIdKey =
      (importingFrom === 'SalesRelease' || importingFrom === 'PurchaseRelease') ? 'releaseId' :
        (importingFrom === 'PurchaseInvoice' || importingFrom === 'SalesInvoice') ? 'invoiceId' :
          (importingFrom === 'Indent') ? 'indentId' :
            (importingFrom === 'PurchaseOrder') ? 'purchaseOrderId' : '';

    const refDetailIdKey = importingFrom === 'PurchaseOrder' ? 'purchaseOrderDetailId' : 'detailId';

    const payload: PurchaseReleaseDetailCreateBulkRequestDTO = {
      releaseId: this.MasterId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      actionUser: this.User.userId.toString(),
      purchaseReleaseDetails: items.map(el => ({
        itemId: ensureNumber(el.itemId),
        qtyType: ensureString(el.qtyType),
        qty: ensureNumber(el.qty),
        remarks: ensureString(el.remarks),
        displaySeq: ensureNumber(el.displaySeq),
        otherDetail1: ensureString(el.otherDetail1),
        otherDetail2: ensureString(el.otherDetail2),
        otherDetail3: ensureString(el.otherDetail3),
        otherDetail4: ensureString(el.otherDetail4),
        otherDetail5: ensureString(el.otherDetail5),
        otherDetail6: ensureString(el.otherDetail6),
        otherDetail7: ensureString(el.otherDetail7),
        otherDetail8: ensureString(el.otherDetail8),
        otherDetail9: ensureString(el.otherDetail9),
        otherDetail10: ensureString(el.otherDetail10),
        otherDetail11: ensureString(el.otherDetail11),
        otherDetail12: ensureString(el.otherDetail12),
        otherDetail13: ensureString(el.otherDetail13),
        otherDetail14: ensureString(el.otherDetail14),
        otherDetail15: ensureString(el.otherDetail15),
        gstRate: ensureNumber(el.gstRate),
        cgstAmt: ensureNumber(el.cgstAmt),
        sgstAmt: ensureNumber(el.sgstAmt),
        igstAmt: ensureNumber(el.igstAmt),
        utgstAmt: ensureNumber(el.utgstAmt),
        cessRate: ensureNumber(el.cessRate),
        cessAmt: ensureNumber(el.cessAmt),
        refMasterType: ensureString(importingFrom),
        refMasterId: ensureNumber((el as any)[refMasterIdKey]),
        refDetailId: ensureNumber((el as any)[refDetailIdKey]),
      }))
    };

    this.purchaseReleaseDetailService.PurchaseReleaseDetail_CreateBulk(payload).subscribe({
      next: () => {
        this.setSubmitting(importingFrom, false);
        this.closeModal(importingFrom);
        this.ReloadList.emit();
      },
      error: err => {
        this.setSubmitting(importingFrom, false);
        console.error(`Failed to bulk add items from ${importingFrom}:`, err);
      }
    });
  }

  CreatePurchaseOrderDetail(items: any[], importingFrom: string) {
    if (!items?.length) return;

    this.setSubmitting(importingFrom, true);

    const refMasterIdKey =
      (importingFrom === 'SalesRelease' || importingFrom === 'PurchaseRelease') ? 'releaseId' :
        (importingFrom === 'PurchaseInvoice' || importingFrom === 'SalesInvoice') ? 'invoiceId' :
          (importingFrom === 'Indent') ? 'indentId' :
            (importingFrom === 'PurchaseOrder') ? 'purchaseOrderId' : '';

    const refDetailIdKey = importingFrom === 'PurchaseOrder' ? 'purchaseOrderDetailId' : 'detailId';

    const payload: PurchaseOrderDetailCreateBulkRequestDTO = {
      purchaseOrderId: this.MasterId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      actionUser: this.User.userId.toString(),
      purchaseOrderDetails: items.map(el => ({
        itemId: ensureNumber(el.itemId),
        itemDescription: ensureString(el.itemDescription),
        qty: ensureNumber(el.qty),
        uomId: ensureNumber(el.uomId),
        price: ensureNumber(el.price || el.rate),
        discount: ensureNumber(el.discount || el.discountAmount),
        discountRate: ensureNumber(el.discountRate),
        tax: ensureNumber(el.tax || el.taxAmount),
        totalAmount: ensureNumber(el.totalAmount),
        deliveryDate: el.deliveryDate || null,
        remarks: ensureString(el.remarks),
        displaySeq: ensureNumber(el.displaySeq),
        qtyType: ensureString(el.qtyType),
        // Plain pass-through, no derivation from qty/qtyType.
        reqQtyType: ensureString(el.reqQtyType),
        reqQty: ensureNumber(el.reqQty),
        isDefault: ensureNumber(el.isDefault),
        otherDetail1: ensureString(el.otherDetail1),
        otherDetail2: ensureString(el.otherDetail2),
        otherDetail3: ensureString(el.otherDetail3),
        otherDetail4: ensureString(el.otherDetail4),
        otherDetail5: ensureString(el.otherDetail5),
        otherDetail6: ensureString(el.otherDetail6),
        otherDetail7: ensureString(el.otherDetail7),
        otherDetail8: ensureString(el.otherDetail8),
        otherDetail9: ensureString(el.otherDetail9),
        otherDetail10: ensureString(el.otherDetail10),
        otherDetail11: ensureString(el.otherDetail11),
        otherDetail12: ensureString(el.otherDetail12),
        otherDetail13: ensureString(el.otherDetail13),
        otherDetail14: ensureString(el.otherDetail14),
        otherDetail15: ensureString(el.otherDetail15),
        refMasterType: ensureString(importingFrom),
        refMasterId: ensureNumber((el as any)[refMasterIdKey]),
        refDetailId: ensureNumber((el as any)[refDetailIdKey]),
        gstRate: ensureNumber(el.gstRate),
        cgstAmt: ensureNumber(el.cgstAmt),
        sgstAmt: ensureNumber(el.sgstAmt),
        igstAmt: ensureNumber(el.igstAmt),
        utgstAmt: ensureNumber(el.utgstAmt),
        cessRate: ensureNumber(el.cessRate),
        cessAmt: ensureNumber(el.cessAmt),
      }))
    };

    this.purchaseOrderDetailService.PurchaseOrderDetail_CreateBulk(payload).subscribe({
      next: () => {
        this.setSubmitting(importingFrom, false);
        this.closeModal(importingFrom);
        this.ReloadList.emit();
      },
      error: err => {
        this.setSubmitting(importingFrom, false);
        console.error(`Failed to bulk add items from ${importingFrom}:`, err);
      }
    });
  }

  // CreatePurchaseOrderDetail(items: any[], importingFrom: string) {
  //   if (!items?.length) return;
  //   let data: PurchaseOrderDetailCreateRequestDTO[] = [];
  //   items.forEach(i => {
  //     console.log(i);
  //   })

  //   data.push(...items.map(el => {
  //     const detail: PurchaseOrderDetailCreateRequestDTO = {
  //       purchaseOrderId: this.MasterId,
  //       itemId: el.itemId,
  //       itemDescription: '',
  //       qty: el.q,
  //       qtyType: '',
  //       uomId: 0,
  //       rate: 0,
  //       discountAmount: 0,
  //       taxAmount: 0,
  //       totalAmount: 0,
  //       deliveryDate: '',
  //       remarks: '',
  //       displaySeq: 0,
  //       otherDetail1: '',
  //       otherDetail2: '',
  //       otherDetail3: '',
  //       otherDetail4: '',
  //       otherDetail5: '',
  //       otherDetail6: '',
  //       actionUser: ''
  //     };

  //     return detail;
  //   }))

  //   this.processItems(items, importingFrom, this.purchaseOrderDetailService.PurchaseOrderDetail_Create.bind(this.purchaseOrderDetailService), 'purchaseOrderId');
  // }

  private processItems(items: any[], importingFrom: string, apiFn: Function, idKey: 'invoiceId' | 'releaseId' | 'indentId' | 'purchaseOrderId' = 'invoiceId') {
    this.setSubmitting(importingFrom, true);

    let refMasterId =
      (importingFrom === 'SalesRelease' || importingFrom === 'PurchaseRelease') ? 'releaseId' :
        (importingFrom === 'PurchaseInvoice' || importingFrom === 'SalesInvoice') ? 'invoiceId' :
          (importingFrom === 'Indent') ? 'indentId' :
            (importingFrom === 'PurchaseOrder') ? 'purchaseOrderId' :
              '';

    let refDetailIdKey =
      (importingFrom === 'PurchaseOrder') ? 'purchaseOrderDetailId' : 'detailId';

    const requests = items.map(el => {
      // Create a clean data object with only the required fields
      const data: any = {
        itemId: el.itemId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        itemDescription: el.itemDescription || '',
        qty: el.qty,
        qtyType: el.qtyType || '',
        remarks: el.remarks || '',
        displaySeq: el.displaySeq || 0,
        otherDetail1: el.otherDetail1 || '',
        otherDetail2: el.otherDetail2 || '',
        otherDetail3: el.otherDetail3 || '',
        otherDetail4: el.otherDetail4 || '',
        otherDetail5: el.otherDetail5 || '',
        otherDetail6: el.otherDetail6 || '',
        refMasterType: importingFrom,
        refMasterId: el[refMasterId],
        refDetailId: el[refDetailIdKey],
        actionUser: this.User.userId.toString(),
      };

      // Add master type specific fields
      if (this.MasterType === 'PurchaseOrder') {
        data.purchaseOrderId = this.MasterId;
        data.uomId = el.uomId || 0;
        data.rate = el.price || el.rate || 0;
        data.discountAmount = el.discount || el.discountAmount || 0;
        data.taxAmount = el.tax || el.taxAmount || 0;
        data.totalAmount = el.totalAmount || 0;
        data.deliveryDate = el.deliveryDate || null;
      } else if (this.MasterType === 'PurchaseInvoice' || this.MasterType === 'SalesInvoice') {
        data.invoiceId = this.MasterId;
        data.price = el.price || 0;
        data.discount = el.discount || 0;
        data.tax = el.tax || 0;
        data.totalAmount = el.totalAmount || 0;
        data.isDefault = el.isDefault || 0;
      } else if (this.MasterType === 'PurchaseRelease' || this.MasterType === 'SalesRelease') {
        data.releaseId = this.MasterId;
        data.price = el.price || 0;
        data.discount = el.discount || 0;
        data.tax = el.tax || 0;
        data.totalAmount = el.totalAmount || 0;
      } else if (this.MasterType === 'Indent') {
        data.indentId = this.MasterId;
      }

      return apiFn(data);
    });

    forkJoin(requests).subscribe({
      next: () => {
        this.setSubmitting(importingFrom, false);
        this.closeModal(importingFrom);
        this.ReloadList.emit();
      },
      error: err => {
        this.setSubmitting(importingFrom, false);
        // Keep modal open if you want user to retry
        console.error(`Failed to add items from ${importingFrom}:`, err);
      }
    });
  }

  OCMService = inject(ObjectConfigMappingService)

  route = inject(ActivatedRoute);
  objectList: ObjectConfigMappingByMenuCodeDTO[] = []
  getObjectId(menuCode: string) {

    const data = {
      menuCode: menuCode,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId
    };

    this.OCMService.ObjectConfigMapping_readByMenuCode(data).subscribe({
      next: (res) => {
        this.objectList = res.list || [];
      }
    });
  }

  /**
   * Check if an object code is visible/available in the configuration
   * @param code - The object code to check (e.g., 'IVIB', 'BMPH', 'BMBH')
   * @returns true if the code exists in objectList, false otherwise
   */
  isObjectCodeVisible(code: string): boolean {
    if (!code || !this.objectList?.length) {
      return false;
    }
    return this.objectList.some(ol =>
      ol.objectCode?.toLowerCase() === code.toLowerCase()
    );
  }
}